import { init as initApm } from '@elastic/apm-rum';
import config from './config';

const apm =
  config.REACT_APP_ENVIRONMENT !== 'development'
    ? initApm({
      serviceName: 'dzo-webshop',
      serverUrl: config.REACT_APP_APM_SERVER_URL,
      environment: config.REACT_APP_ENVIRONMENT,
      serviceVersion: '1.0.0',
      breakdownMetrics: true,
    })
    : undefined;

// Third-party scripts (GTM, VWO) throw opaque cross-origin "Script error." — drop those and
// the ResizeObserver noise from the payload; the agent has no ignoreErrors option.
const IGNORED_ERROR_MESSAGES = [/^Script error\.?$/, /ResizeObserver loop/];

apm?.addFilter((payload) => {
  if (Array.isArray(payload?.errors)) {
    payload.errors = payload.errors.filter(
      (error: { exception?: { message?: string } }) =>
        !IGNORED_ERROR_MESSAGES.some((pattern) => pattern.test(error?.exception?.message ?? ''))
    );
  }
  return payload;
});

export default apm;
